export default {
  "content": "<path class=\"positive-arrow-up-st0 arrow-up-path\" d=\"M15.4.5L.5 15.4c-.5.5-.7 1.3-.4 2 .3.7.9 1.1 1.7 1.1h7.9V57h13.8V18.5h7.9c.7 0 1.4-.4 1.7-1.1.1-.2.1-.5.1-.7 0-.5-.2-.9-.5-1.3L18 .5c-.4-.3-.9-.5-1.3-.5-.5 0-1 .2-1.3.5z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 33.3 56.9"
  }
};